import { searchKeys } from '@schibsted-nmp/search-frontend-clients/quest';
import mFinnLinks from '@finn-no/search-mfinn-links';
import { i18n } from '@lingui/core';

// src/getSearchPath.ts

// src/auroraPlatform.ts
var getAuroraBrowsePath = (searchKey) => {
  switch (searchKey) {
    case "SEARCH_ID_CAR_USED":
    case "SEARCH_ID_CAR_PARALLEL_IMPORT":
    // deprecated
    case "SEARCH_ID_CAR_MOBILE_HOME":
    case "SEARCH_ID_CAR_CARAVAN":
    case "SEARCH_ID_CAR_VAN":
    // deprecated
    case "SEARCH_ID_CAR_VAN_ABROAD":
      return "/mobility/browse/car";
    case "SEARCH_ID_BOAT_PARTS":
    case "SEARCH_ID_BOAT_MOTOR":
    case "SEARCH_ID_BOAT_PARTS_MOTOR_WANTED":
    // deprecated
    case "SEARCH_ID_BOAT_USED":
    case "SEARCH_ID_BOAT_USED_WANTED":
    // deprecated
    case "SEARCH_ID_BOAT_RENT":
    // deprecated
    case "SEARCH_ID_BOAT_NEW":
    case "SEARCH_ID_BOAT_DOCK":
    case "SEARCH_ID_BOAT_DOCK_WANTED":
      return "/mobility/browse/boat";
    case "SEARCH_ID_CAR_TRUCK":
    case "SEARCH_ID_CAR_TRUCK_ABROAD":
    case "SEARCH_ID_AGRICULTURE_THRESHING":
    case "SEARCH_ID_AGRICULTURE_TRACTOR":
    case "SEARCH_ID_AGRICULTURE_TOOL":
    case "SEARCH_ID_CAR_BUS":
    case "SEARCH_ID_CAR_AGRI":
      return "/mobility/browse/b2b";
    case "SEARCH_ID_MC_USED":
    case "SEARCH_ID_MC_SCOOTER":
    case "SEARCH_ID_MC_ATV":
    case "SEARCH_ID_MC_SNOWMOBILE":
      return "/mobility/browse/mc";
    default:
      throw new Error(`Unknown searchkey: ${searchKey}`);
  }
};
var getAuroraSearchPath = (searchKey, searchParams) => {
  const urlGenerator = urlGeneratorFactory(searchParams);
  switch (searchKey) {
    case "SEARCH_ID_CAR_USED":
      return urlGenerator("/mobility/search/car");
    case "SEARCH_ID_CAR_PARALLEL_IMPORT":
      return urlGenerator("/mobility/search/car", [["location", "20534"]]);
    case "SEARCH_ID_CAR_MOBILE_HOME":
      return urlGenerator("/mobility/search/car/mobilehome");
    case "SEARCH_ID_BAP_COMMON":
    case "SEARCH_ID_BAP_ALL":
      return urlGenerator("/recommerce/forsale/search");
    case "SEARCH_ID_BOAT_PARTS":
      return urlGenerator("/mobility/search/boat/engine/parts");
    case "SEARCH_ID_BOAT_MOTOR":
      return urlGenerator("/mobility/search/boat/engine");
    case "SEARCH_ID_BOAT_PARTS_MOTOR_WANTED":
      return urlGenerator("/mobility/search/boat/engine", [["sales_form", "3"]]);
    case "SEARCH_ID_CAR_VAN":
      return urlGenerator("/mobility/search/car", [
        ["registration_class", "2"],
        ["registration_class", "8"]
      ]);
    case "SEARCH_ID_CAR_VAN_ABROAD":
      return urlGenerator("/mobility/search/car", [
        ["registration_class", "2"],
        ["registration_class", "8"],
        ["location", "20534"]
      ]);
    case "SEARCH_ID_CAR_CARAVAN":
      return urlGenerator("/mobility/search/car/caravan");
    case "SEARCH_ID_BOAT_USED":
      return urlGenerator("/mobility/search/boat");
    case "SEARCH_ID_BOAT_USED_WANTED":
      return urlGenerator("/mobility/search/boat", [["sales_form", "wanted"]]);
    case "SEARCH_ID_BOAT_RENT":
      return urlGenerator("/mobility/search/boat", [["sales_form", "rent"]]);
    case "SEARCH_ID_BOAT_NEW":
      return urlGenerator("/mobility/search/boat", [["boat_condition", "121"]]);
    case "SEARCH_ID_MC_USED":
      return urlGenerator("/mobility/search/mc");
    case "SEARCH_ID_MC_SCOOTER":
      return urlGenerator("/mobility/search/scooter");
    case "SEARCH_ID_MC_ATV":
      return urlGenerator("/mobility/search/atv");
    case "SEARCH_ID_MC_SNOWMOBILE":
      return urlGenerator("/mobility/search/snowmobile");
    case "SEARCH_ID_CAR_TRUCK":
      return urlGenerator("/mobility/search/b2b/truck");
    case "SEARCH_ID_CAR_TRUCK_ABROAD":
      return urlGenerator("/mobility/search/b2b/truck", [["location", "20534"]]);
    case "SEARCH_ID_AGRICULTURE_THRESHING":
      return urlGenerator("/mobility/search/b2b/agriculturecombines");
    case "SEARCH_ID_AGRICULTURE_TRACTOR":
      return urlGenerator("/mobility/search/b2b/agriculturetractor");
    case "SEARCH_ID_AGRICULTURE_TOOL":
      return urlGenerator("/mobility/search/b2b/agriculturetools");
    case "SEARCH_ID_CAR_BUS":
      return urlGenerator("/mobility/search/b2b/bus");
    case "SEARCH_ID_CAR_AGRI":
      return urlGenerator("/mobility/search/b2b/construction");
    case "SEARCH_ID_BOAT_DOCK":
      return urlGenerator("/mobility/search/boat/dock");
    case "SEARCH_ID_BOAT_DOCK_WANTED":
      return urlGenerator("/mobility/search/boat/dock", [["sales_form", "wanted"]]);
    default:
      throw new Error(`Unknown searchkey: ${searchKey}`);
  }
};
var urlGeneratorFactory = (searchParams) => (url, categorySearchParams) => {
  if (categorySearchParams && categorySearchParams.length > 0) {
    categorySearchParams.forEach((categorySearchParam) => {
      const [key, value] = categorySearchParam;
      searchParams.append(key, value);
    });
  }
  const searchParamsString = searchParams.size > 0 ? `?${searchParams.toString()}` : "";
  return `${url}${searchParamsString}`;
};
[...searchKeys];
var getSearchPath = (searchKey, searchParams = new URLSearchParams(), platform = "aurora") => {
  switch (platform) {
    case "aurora":
      return getAuroraSearchPath(searchKey, searchParams);
    case "legacy":
      searchParams.append("filters", "");
      return `/${mFinnLinks(searchKey)}?${searchParams.toString()}`;
    default:
      throw new Error(`Unknown platform: ${platform}`);
  }
};

// src/getTrackingEventCategory/getTrackingEventCategory.ts
var getCategoryObject = (searchKey, searchParams) => {
  var _a, _b, _c, _d;
  switch (searchKey) {
    case "SEARCH_ID_CAR_USED": {
      if (searchParams.size > 0 && ((_a = searchParams.getAll("registration_class")) == null ? void 0 : _a.every((param) => param === "2" || param === "8"))) {
        return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Vans" };
      }
      return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Cars" };
    }
    case "SEARCH_ID_CAR_PARALLEL_IMPORT":
      return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Cars" };
    case "SEARCH_ID_CAR_MOBILE_HOME":
      return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Motor homes" };
    case "SEARCH_ID_CAR_VAN":
    // deprecated
    case "SEARCH_ID_CAR_VAN_ABROAD":
      return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Vans" };
    case "SEARCH_ID_CAR_CARAVAN":
      return { mainCategory: "Cars and caravans" /* carsAndCaravans */, subCategory: "Caravans" };
    case "SEARCH_ID_BOAT_PARTS":
      return { mainCategory: "Boats" /* boats */, subCategory: "Engine parts" };
    case "SEARCH_ID_BOAT_MOTOR": {
      if (searchParams.size > 0 && ((_b = searchParams.getAll("sales_form")) == null ? void 0 : _b.every((param) => param === "3"))) {
        return { mainCategory: "Boats" /* boats */, subCategory: "Engine wanted" };
      }
      return { mainCategory: "Boats" /* boats */, subCategory: "Engine" };
    }
    case "SEARCH_ID_BOAT_PARTS_MOTOR_WANTED":
      return { mainCategory: "Boats" /* boats */, subCategory: "Engine wanted" };
    case "SEARCH_ID_BOAT_USED": {
      if (searchParams.size > 0) {
        if ((_c = searchParams.getAll("sales_form")) == null ? void 0 : _c.every((param) => param === "122")) {
          return { mainCategory: "Boats" /* boats */, subCategory: "Boats for rent" };
        } else if ((_d = searchParams.getAll("sales_form")) == null ? void 0 : _d.every((param) => param === "77")) {
          return { mainCategory: "Boats" /* boats */, subCategory: "Boats wanted" };
        } else {
          return { mainCategory: "Boats" /* boats */, subCategory: "Boats for sale" };
        }
      }
      return { mainCategory: "Boats" /* boats */, subCategory: "Boats for sale" };
    }
    case "SEARCH_ID_BOAT_USED_WANTED":
      return { mainCategory: "Boats" /* boats */, subCategory: "Boats wanted" };
    case "SEARCH_ID_BOAT_RENT":
      return { mainCategory: "Boats" /* boats */, subCategory: "Boats for rent" };
    case "SEARCH_ID_BOAT_DOCK":
      return { mainCategory: "Boats" /* boats */, subCategory: "Dock for sale/rent" };
    case "SEARCH_ID_BOAT_DOCK_WANTED":
      return { mainCategory: "Boats" /* boats */, subCategory: "Dock wanted" };
    case "SEARCH_ID_MC_USED":
      return { mainCategory: "MC" /* mc */, subCategory: "Motorcycles" };
    case "SEARCH_ID_MC_SCOOTER":
      return { mainCategory: "MC" /* mc */, subCategory: "Scooters and mopeds" };
    case "SEARCH_ID_MC_ATV":
      return { mainCategory: "MC" /* mc */, subCategory: "ATV" };
    case "SEARCH_ID_MC_SNOWMOBILE":
      return { mainCategory: "MC" /* mc */, subCategory: "Snowscooters" };
    case "SEARCH_ID_CAR_TRUCK":
    case "SEARCH_ID_CAR_TRUCK_ABROAD":
      return { mainCategory: "Business" /* business */, subCategory: "Trucks" };
    case "SEARCH_ID_AGRICULTURE_THRESHING":
      return { mainCategory: "Business" /* business */, subCategory: "Threshers" };
    case "SEARCH_ID_AGRICULTURE_TRACTOR":
      return { mainCategory: "Business" /* business */, subCategory: "Tractors" };
    case "SEARCH_ID_AGRICULTURE_TOOL":
      return { mainCategory: "Business" /* business */, subCategory: "Tools" };
    case "SEARCH_ID_CAR_BUS":
      return { mainCategory: "Business" /* business */, subCategory: "Buses" };
    case "SEARCH_ID_CAR_AGRI":
      return { mainCategory: "Business" /* business */, subCategory: "Construction" };
    default:
      return { mainCategory: "n/a" /* n_a */, subCategory: "" };
  }
};
var getTrackingEventCategory = (searchKey, searchParams) => {
  const { mainCategory, subCategory } = getCategoryObject(searchKey, searchParams);
  return [mainCategory, subCategory].filter(Boolean).join(" > ");
};
[...searchKeys];
var getBrowsePath = (searchKey, platform = "aurora") => {
  switch (platform) {
    case "aurora":
      return getAuroraBrowsePath(searchKey);
    case "legacy":
      return `/${mFinnLinks(searchKey, "MARKET")}`;
    default:
      throw new Error(`Unknown platform: ${platform}`);
  }
};

// src/brand.ts
var getBrandFromUrl = (url) => {
  if (url.host.includes("finn.no")) {
    return "FINN" /* FINN */;
  } else if (url.host.includes("dba.dk")) {
    return "DBA" /* DBA */;
  } else if (url.host.includes("blocket.se")) {
    return "BLOCKET" /* BLOCKET */;
  } else {
    throw new Error(`Could not resolve brand from url ${url}`);
  }
};

// src/getBreadcrumbs/resolveBreadcrumbForUrl.ts
function hasKeyWithOnlyValues(queryParams, targetKey, targetValues) {
  const entry = queryParams.find((param) => param.key === targetKey);
  if (!entry) return false;
  return targetValues.every((value) => entry.values.includes(value));
}
function hasKeyContainingValues(queryParams, targetKey, targetValues) {
  const entry = queryParams.find((param) => param.key === targetKey);
  if (!entry) return false;
  return targetValues.some((value) => entry.values.includes(value));
}
function extractQueryParams(searchParams) {
  const searchPageParams = ["sales_form", "registration_class"];
  return searchPageParams.reduce((acc, param) => {
    const values = searchParams.getAll(param);
    if (values.length > 0) {
      acc.push({ key: param, values });
    }
    return acc;
  }, []);
}
var subVerticalMap = {
  ["car" /* Car */]: {
    path: "/mobility/browse/car",
    text: () => i18n.t({ id: "car-and-caravan", message: "Car and caravan" })
  },
  ["boat" /* Boat */]: {
    path: "/mobility/browse/boat",
    text: () => i18n.t({ id: "boat", message: "Boat" })
  },
  ["b2b" /* B2b */]: {
    path: "/mobility/browse/b2b",
    text: () => i18n.t({ id: "b2b", message: "Business" })
  },
  ["mc" /* Mc */]: {
    path: "/mobility/browse/mc",
    text: () => i18n.t({ id: "mc", message: "Motorcycle" })
  }
};
var resolveBreadcrumbForUrl = (url) => {
  const searchPageParams = url.searchParams ? extractQueryParams(url.searchParams) : [];
  const searchPagePath = url.pathname;
  const breadcrumbs = [];
  switch (searchPagePath) {
    case "/mobility/search/boat": {
      const subVerticalBreadcrumb = subVerticalMap["boat" /* Boat */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      if (hasKeyWithOnlyValues(searchPageParams, "sales_form", ["122"])) {
        breadcrumbs.push({
          path: url.pathname + `?sales_form=122`,
          text: i18n.t({ id: "boats-for-rent", message: "Boats for rent" })
        });
      } else if (hasKeyWithOnlyValues(searchPageParams, "sales_form", ["77"])) {
        breadcrumbs.push({
          path: url.pathname + `?sales_form=77`,
          text: i18n.t({ id: "boats-wanted", message: "Boats wanted" })
        });
      } else {
        breadcrumbs.push({
          path: url.pathname,
          text: i18n.t({ id: "boats-for-sale", message: "Boats for sale" })
        });
      }
      return breadcrumbs;
    }
    case "/mobility/search/boat/engine": {
      const subVerticalBreadcrumb = subVerticalMap["boat" /* Boat */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      if (hasKeyWithOnlyValues(searchPageParams, "sales_form", ["3"])) {
        breadcrumbs.push({
          path: url.pathname + `?sales_form=3`,
          text: i18n.t({ id: "boat-engines-wanted", message: "Boat engines wanted" })
        });
      } else {
        breadcrumbs.push({
          path: url.pathname,
          text: i18n.t({ id: "boat-engines-for-sale", message: "Boat engines for sale" })
        });
      }
      return breadcrumbs;
    }
    case "/mobility/search/boat/engine/parts": {
      const subVerticalBreadcrumb = subVerticalMap["boat" /* Boat */];
      breadcrumbs.push(
        { path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() },
        { path: url.pathname, text: i18n.t({ id: "boat-engine-parts", message: "Boat engine parts" }) }
      );
      return breadcrumbs;
    }
    case "/mobility/search/boat/dock": {
      const subVerticalBreadcrumb = subVerticalMap["boat" /* Boat */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      if (hasKeyWithOnlyValues(searchPageParams, "sales_form", ["wanted"])) {
        breadcrumbs.push({
          path: url.pathname + `?sales_form=wanted`,
          text: i18n.t({ id: "boat-docks-wanted", message: "Boat docks wanted" })
        });
      } else {
        breadcrumbs.push({
          path: url.pathname,
          text: i18n.t({ id: "boat-docks-for-sale", message: "Boat docks for sale/rent" })
        });
      }
      return breadcrumbs;
    }
    case "/mobility/search/car": {
      const subVerticalBreadcrumb = subVerticalMap["car" /* Car */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      if (!hasKeyWithOnlyValues(searchPageParams, "registration_class", ["1"]) && hasKeyContainingValues(searchPageParams, "registration_class", ["2", "8"])) {
        let queryParams = `?registration_class=2`;
        if (getBrandFromUrl(url) !== "FINN" /* FINN */) {
          queryParams += `&registration_class=8`;
        }
        breadcrumbs.push({
          path: url.pathname + queryParams,
          text: i18n.t({ id: "vans", message: "Vans" })
        });
      } else {
        breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "cars", message: "Cars" }) });
      }
      return breadcrumbs;
    }
    case "/mobility/search/car/mobilehome": {
      const subVerticalBreadcrumb = subVerticalMap["car" /* Car */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "mobilehomes", message: "Mobile homes" }) });
      return breadcrumbs;
    }
    case "/mobility/search/car/caravan": {
      const subVerticalBreadcrumb = subVerticalMap["car" /* Car */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "caravans", message: "Caravans" }) });
      return breadcrumbs;
    }
    case "/mobility/search/mc": {
      const subVerticalBreadcrumb = subVerticalMap["mc" /* Mc */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "motorcycles", message: "Motorcycles" }) });
      return breadcrumbs;
    }
    case "/mobility/search/scooter": {
      const subVerticalBreadcrumb = subVerticalMap["mc" /* Mc */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({
        path: url.pathname,
        text: i18n.t({ id: "scooters-and-mopeds", message: "Scooters and mopeds" })
      });
      return breadcrumbs;
    }
    case "/mobility/search/atv": {
      const subVerticalBreadcrumb = subVerticalMap["mc" /* Mc */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "atvs", message: "ATVs" }) });
      return breadcrumbs;
    }
    case "/mobility/search/snowmobile": {
      const subVerticalBreadcrumb = subVerticalMap["mc" /* Mc */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "snowmobiles", message: "Snowmobiles" }) });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/agriculturetractor": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "tractors", message: "Tractors" }) });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/agriculturecombines": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({ path: url.pathname, text: i18n.t({ id: "harvesters", message: "Harvesters" }) });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/agriculturetools": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({
        path: url.pathname,
        text: i18n.t({ id: "agriculture-tools", message: "Agriculture tools" })
      });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/truck": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({
        path: url.pathname,
        text: i18n.t({ id: "trucks-and-trailers", message: "Trucks and trailers" })
      });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/bus": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({
        path: url.pathname,
        text: i18n.t({ id: "buses-and-minibuses", message: "Buses and minibuses" })
      });
      return breadcrumbs;
    }
    case "/mobility/search/b2b/construction": {
      const subVerticalBreadcrumb = subVerticalMap["b2b" /* B2b */];
      breadcrumbs.push({ path: subVerticalBreadcrumb.path, text: subVerticalBreadcrumb.text() });
      breadcrumbs.push({
        path: url.pathname,
        text: i18n.t({ id: "construction", message: "Construction and engineering" })
      });
      return breadcrumbs;
    }
  }
  return [];
};

// src/getBreadcrumbs/adTypeGuards.ts
var isCarAd = (ad) => {
  return isCar(ad.adViewType);
};
var isVan = (ad) => {
  var _a, _b;
  if (isCarAd(ad)) {
    return ((_a = ad.registration_class) == null ? void 0 : _a.id) === 2 || ((_b = ad.registration_class) == null ? void 0 : _b.id) === 8;
  }
  return false;
};
var isCar = (adViewType) => {
  const carSchemas = ["car-used", "car-new", "car-used-business", "car-leasing-business", "car-leasing"];
  return carSchemas.includes(adViewType || "");
};
var isBoatForSaleAd = (ad) => {
  return ["boat-sale", "boat-new-sale"].includes(ad.adViewType);
};
var isBoatForRent = (ad) => {
  return ad.adViewType === "boat-rent";
};
var isBoatWantedAd = (ad) => {
  return ad.adViewType === "boat-wanted";
};
var isBoatMotorAd = (ad) => {
  return ad.adViewType === "boat-motor";
};
var isBoatDockAd = (ad) => {
  return ad.adViewType === "boat-dock";
};
var isMotorbikeSubverticalAd = (ad) => {
  return isMotorbike(ad.adViewType);
};
var isMotorcycleAd = (ad) => {
  return ad.adViewType === "motorcycle";
};
var isMopedAd = (ad) => {
  return ad.adViewType === "moped";
};
var isSnowmobileAd = (ad) => {
  return ad.adViewType === "snowmobile";
};
var isAtvAd = (ad) => {
  return ad.adViewType === "atv";
};
var isMotorbike = (adViewType) => {
  const motorcycleSchemas = ["motorcycle", "moped", "atv", "snowmobile"];
  return motorcycleSchemas.includes(adViewType || "");
};
var isTractorAd = (ad) => {
  return ad.adViewType === "agriculture-tractor";
};
var isThresherAd = (ad) => {
  return ad.adViewType === "agriculture-thresher";
};
var isAgricultureToolsAd = (ad) => {
  return ad.adViewType === "agriculture-tools";
};
var isMobileHomeAd = (ad) => {
  return isMobileHome(ad.adViewType);
};
var isMobileHome = (adViewType) => {
  const mobileHomeSchemas = ["mobile-home"];
  return mobileHomeSchemas.includes(adViewType || "");
};
var isCaravanAd = (ad) => {
  return isCaravan(ad.adViewType);
};
var isCaravan = (adViewType) => {
  const caravanHomeSchemas = ["caravan"];
  return caravanHomeSchemas.includes(adViewType || "");
};

// src/getBreadcrumbs/resolveBreadcrumbForAd.ts
var UnsupportedAdTypeError = class extends Error {
  constructor(adType) {
    super(`Ad type is not supported: ${adType}`);
    this.name = "UnsupportedAdTypeError";
  }
};
var resolveBreadcrumbForAd = (ad, originUrl) => {
  for (const group of Object.values(adTypeHandlers)) {
    const { guard } = group;
    if (guard(ad)) {
      const handler = group.handler;
      return handler(ad, originUrl);
    }
  }
  throw new UnsupportedAdTypeError(ad.adViewType);
};
var adTypeHandlers = {
  car: {
    guard: isCarAd,
    handler: handleCarAd
  },
  mobileHome: {
    guard: isMobileHomeAd,
    handler: handleSimpleAd("SEARCH_ID_CAR_MOBILE_HOME")
  },
  caravan: {
    guard: isCaravanAd,
    handler: handleSimpleAd("SEARCH_ID_CAR_CARAVAN")
  },
  boatForSale: {
    guard: isBoatForSaleAd,
    handler: handleBoatAd
  },
  boatForRent: {
    guard: isBoatForRent,
    handler: handleBoatAd
  },
  boatWanted: {
    guard: isBoatWantedAd,
    handler: handleBoatAd
  },
  boatMotor: {
    guard: isBoatMotorAd,
    handler: handleBoatMotorAd
  },
  boatDock: {
    guard: isBoatDockAd,
    handler: handleBoatDockAd
  },
  motorcycle: {
    guard: isMotorcycleAd,
    handler: handleSimpleAd("SEARCH_ID_MC_USED")
  },
  moped: {
    guard: isMopedAd,
    handler: handleSimpleAd("SEARCH_ID_MC_SCOOTER")
  },
  snowmobile: {
    guard: isSnowmobileAd,
    handler: handleSimpleAd("SEARCH_ID_MC_SNOWMOBILE")
  },
  atv: {
    guard: isAtvAd,
    handler: handleSimpleAd("SEARCH_ID_MC_ATV")
  },
  tractor: {
    guard: isTractorAd,
    handler: handleSimpleAd("SEARCH_ID_AGRICULTURE_TRACTOR")
  },
  thresher: {
    guard: isThresherAd,
    handler: handleSimpleAd("SEARCH_ID_AGRICULTURE_THRESHING")
  },
  agricultureTools: {
    guard: isAgricultureToolsAd,
    handler: handleSimpleAd("SEARCH_ID_AGRICULTURE_TOOL")
  }
};
function handleSimpleAd(searchId, includeBreadcrumbs = true) {
  return (ad, originUrl) => {
    const searchPage = getSearchPath(searchId);
    const searchPageUrl = new URL(searchPage, originUrl);
    const breadcrumbs = resolveBreadcrumbForUrl(searchPageUrl);
    if (includeBreadcrumbs) {
      return [...breadcrumbs, ...getBreadcrumbsFromAd(ad, searchPageUrl)];
    }
    return breadcrumbs;
  };
}
function handleBoatAd(ad, originUrl) {
  let searchParams = new URLSearchParams();
  if (isBoatForRent(ad)) {
    searchParams.append("sales_form", "122");
  } else if (isBoatWantedAd(ad)) {
    searchParams.append("sales_form", "77");
  }
  const searchPageUrl = getSearchPath("SEARCH_ID_BOAT_USED", searchParams);
  const searchPageUrlFull = new URL(searchPageUrl, originUrl);
  return [
    ...resolveBreadcrumbForUrl(new URL(searchPageUrl, originUrl)),
    ...getBreadcrumbsFromAd(ad, searchPageUrlFull)
  ];
}
function handleCarAd(ad, originUrl) {
  var _a;
  const searchId = "SEARCH_ID_CAR_USED";
  let searchParams = new URLSearchParams();
  if (isVan(ad)) {
    searchParams.append("registration_class", "2");
    if (getBrandFromUrl(new URL(originUrl)) !== "FINN" /* FINN */) {
      searchParams.append("registration_class", "8");
    }
  }
  if (isCarAd(ad) && ((_a = ad.car_location) == null ? void 0 : _a.id) === 2) {
    searchParams.append("location", "20534");
  }
  const searchPageUrl = getSearchPath(searchId, searchParams);
  const searchPageUrlFull = new URL(searchPageUrl, originUrl);
  return [
    ...resolveBreadcrumbForUrl(new URL(searchPageUrl, originUrl)),
    ...getBreadcrumbsFromAd(ad, searchPageUrlFull)
  ];
}
function handleBoatMotorAd(ad, originUrl) {
  var _a;
  let searchId;
  let searchParams = new URLSearchParams();
  switch ((_a = ad.trade_type) == null ? void 0 : _a.id) {
    case 3:
      searchId = "SEARCH_ID_BOAT_MOTOR";
      searchParams.append("sales_form", "3");
      break;
    case 20:
      searchId = "SEARCH_ID_BOAT_PARTS";
      break;
    default:
      searchId = "SEARCH_ID_BOAT_MOTOR";
      break;
  }
  const searchPageUrl = getSearchPath(searchId, searchParams);
  return resolveBreadcrumbForUrl(new URL(searchPageUrl, originUrl));
}
function handleBoatDockAd(ad, originUrl) {
  var _a;
  const searchId = ((_a = ad.trade_type) == null ? void 0 : _a.id) === 30 ? "SEARCH_ID_BOAT_DOCK_WANTED" : "SEARCH_ID_BOAT_DOCK";
  const searchPageUrl = getSearchPath(searchId);
  return resolveBreadcrumbForUrl(new URL(searchPageUrl, originUrl));
}
function getBreadcrumbsFromAd(ad, searchPageUrl) {
  var _a;
  const paths = [];
  if (isCarAd(ad)) {
    if ((_a = ad.model_and_make) == null ? void 0 : _a.parent) {
      const makeUrl = new URL(searchPageUrl);
      makeUrl.searchParams.append("make", `0.${ad.model_and_make.parent.id}`);
      paths.push({
        text: ad.model_and_make.parent.value,
        path: `${makeUrl.pathname}${makeUrl.search}`
      });
      const modelUrl = new URL(searchPageUrl);
      modelUrl.searchParams.append("model", `1.${ad.model_and_make.parent.id}.${ad.model_and_make.id}`);
      paths.push({
        text: ad.model_and_make.value,
        path: `${modelUrl.pathname}${modelUrl.search}`
      });
    } else if (ad.model_and_make) {
      const makeUrl = new URL(searchPageUrl);
      makeUrl.searchParams.append("make", `0.${ad.model_and_make.id}`);
      paths.push({
        text: ad.model_and_make.value,
        path: `${makeUrl.pathname}${makeUrl.search}`
      });
    }
  } else if (isAgricultureToolsAd(ad)) {
    if (ad.category) {
      const makeUrl = new URL(searchPageUrl);
      makeUrl.searchParams.append("category", `${ad.category.id}`);
      paths.push({
        text: ad.category.value,
        path: `${makeUrl.pathname}${makeUrl.search}`
      });
    }
  } else if (isTractorAd(ad) || isThresherAd(ad)) {
    if (ad.make) {
      const makeUrl = new URL(searchPageUrl);
      makeUrl.searchParams.append("make", `0.${ad.make.id}`);
      paths.push({
        text: ad.make.value,
        path: `${makeUrl.pathname}${makeUrl.search}`
      });
    }
  } else if (isMobileHomeAd(ad) || isCaravanAd(ad) || isBoatForSaleAd(ad) || isBoatForRent(ad) || isMotorbikeSubverticalAd(ad) || isMotorcycleAd(ad) || isMopedAd(ad) || isSnowmobileAd(ad) || isAtvAd(ad)) {
    if (ad.make) {
      const makeUrl = new URL(searchPageUrl);
      makeUrl.searchParams.append("make", `${ad.make.id}`);
      paths.push({
        text: ad.make.value,
        path: `${makeUrl.pathname}${makeUrl.search}`
      });
    }
  }
  return paths;
}

// src/getBreadcrumbs/jsonLd.ts
var sortPriorityMap = {
  make: 10,
  model: 20,
  body_type: 30,
  exterior_colour: 40,
  fuel: 50
};
var getBrandName = (baseUrl) => {
  if (baseUrl.includes("finn.no")) {
    return "FINN";
  } else if (baseUrl.includes("dba.dk")) {
    return "DBA";
  } else if (baseUrl.includes("blocket.se")) {
    return "Blocket";
  } else return null;
};
var getJsonLdForBreadcrumbs = (breadCrumbs, baseUrl, searchParameters) => {
  var _a;
  const brandName = getBrandName(baseUrl);
  const initialBreadcrumbs = [
    ...brandName ? [{ path: "/", text: brandName }] : [],
    ...breadCrumbs
  ];
  const itemListElement = initialBreadcrumbs.map((breadcrumb, index) => ({
    "@type": "ListItem",
    item: {
      "@id": baseUrl + breadcrumb.path,
      name: breadcrumb.text
    }
  }));
  if (searchParameters) {
    for (const [key, value] of searchParameters.searchUrl.searchParams.entries()) {
      const parameterValue = (_a = searchParameters.valueMap[key]) == null ? void 0 : _a[value];
      if (!parameterValue) {
        continue;
      }
      const priority = sortPriorityMap[key];
      if (!priority) {
        continue;
      }
      if (key === "model") {
        const makeId = `0.${value.split(".")[1]}`;
        const makeName = searchParameters.valueMap.make[makeId];
        const makeUrl = `${searchParameters.searchUrl.origin + searchParameters.searchUrl.pathname}?make=${makeId}`;
        if (!itemListElement.some((item) => item.item["@id"] === makeUrl)) {
          itemListElement.push({
            "@type": "ListItem",
            item: {
              "@id": makeUrl,
              name: makeName
            },
            _meta: {
              key: "make",
              priority: sortPriorityMap.make
            }
          });
        }
      }
      itemListElement.push({
        "@type": "ListItem",
        item: {
          "@id": `${searchParameters.searchUrl.origin + searchParameters.searchUrl.pathname}?${key}=${value}`,
          name: parameterValue
        },
        _meta: {
          key,
          priority
        }
      });
    }
  }
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: postProcessItemList(itemListElement)
  };
  return jsonLd;
};
var filterMakeAndModel = (itemList) => {
  let make;
  let model;
  itemList.forEach((potentialMakeItem) => {
    var _a;
    if (!potentialMakeItem._meta) {
      return;
    }
    if (potentialMakeItem._meta.key !== "make") {
      return;
    }
    if (make || model) {
      return;
    }
    const makeUrl = new URL(potentialMakeItem.item["@id"]);
    const makeId = (_a = makeUrl.searchParams.get("make")) == null ? void 0 : _a.split(".")[1];
    if (!makeId) {
      return;
    }
    const relatedModel = itemList.find((potentialModel) => {
      var _a2;
      if (!potentialModel._meta) {
        return false;
      }
      if (potentialModel._meta.key !== "model") {
        return false;
      }
      const modelUrl = new URL(potentialModel.item["@id"]);
      const modelId = (_a2 = modelUrl.searchParams.get("model")) == null ? void 0 : _a2.split(".")[1];
      if (!modelUrl) {
        return false;
      }
      return modelId === makeId;
    });
    if (relatedModel) {
      make = potentialMakeItem;
      model = relatedModel;
    }
  });
  if (make && model) {
    return itemList.filter((item) => {
      if (!item._meta) {
        return true;
      }
      if (item._meta.key === "make") {
        return make && item.item["@id"] === make.item["@id"];
      } else if (item._meta.key === "model") {
        return model && item.item["@id"] === model.item["@id"];
      } else {
        return true;
      }
    });
  } else {
    let foundMake = false;
    return itemList.filter((item) => {
      var _a;
      if (((_a = item._meta) == null ? void 0 : _a.key) === "make") {
        if (foundMake === false) {
          foundMake = true;
          return true;
        } else {
          return false;
        }
      }
      return true;
    });
  }
};
var postProcessItemList = (itemList) => {
  let postProcessedList = [...itemList];
  postProcessedList = itemList.sort((a, b) => {
    if (!a._meta || !b._meta) {
      return 0;
    }
    const delta = a._meta.priority - b._meta.priority;
    if (delta !== 0) {
      return delta;
    }
    return a.item.name.localeCompare(b.item.name);
  });
  postProcessedList = filterMakeAndModel(postProcessedList);
  postProcessedList = postProcessedList.slice(0, 5);
  return postProcessedList.map((v, i) => {
    const obj = { ...v, position: i + 1 };
    delete obj._meta;
    return obj;
  });
};

// locales/en.mjs
var messages = JSON.parse('{"agriculture-tools":"Agriculture tools","atvs":"ATVs","boat":"Boat","boat-docks-for-sale":"Boat docks for sale/rent","boat-docks-wanted":"Boat docks wanted","boat-engine-parts":"Boat engine parts","boat-engines-for-sale":"Boat engines for sale","boat-engines-wanted":"Boat engines wanted","boats-for-rent":"Boats for rent","boats-for-sale":"Boats for sale","boats-wanted":"Boats wanted","buses-and-minibuses":"Buses and minibuses","b2b":"Commercial vehicles and machinery","car-and-caravan":"Car and Caravan","caravans":"Caravans","cars":"Cars","construction":"Construction and engineering","harvesters":"Harvesters","mobilehomes":"Mobile homes","mc":"Motorcycle","motorcycles":"Motorcycles","scooters-and-mopeds":"Scooters and mopeds","snowmobiles":"Snowmobiles","tractors":"Tractors","trucks-and-trailers":"Trucks and trailers","vans":"Vans"}');

// locales/nb.mjs
var messages2 = JSON.parse('{"agriculture-tools":"Maskiner og redskap","atvs":"ATV-er","boat":"B\xE5t","boat-docks-for-sale":"B\xE5tplasser til salgs/leie","boat-docks-wanted":"B\xE5tplasser \xF8nskes","boat-engine-parts":"Deler til b\xE5tmotor","boat-engines-for-sale":"B\xE5tmotorer til salgs","boat-engines-wanted":"B\xE5tmotorer \xF8nskes kj\xF8pt","boats-for-rent":"B\xE5ter til leie","boats-for-sale":"B\xE5ter til salgs","boats-wanted":"B\xE5ter \xF8nskes kj\xF8pt","buses-and-minibuses":"Busser og minibusser","b2b":"Nyttekj\xF8ret\xF8y og maskiner","car-and-caravan":"Bil og campingvogn","caravans":"Campingvogner","cars":"Biler","construction":"Bygg og anlegg","harvesters":"Treskere","mobilehomes":"Bobiler","mc":"MC","motorcycles":"Motorsykler","scooters-and-mopeds":"Scootere og mopeder","snowmobiles":"Sn\xF8scootere","tractors":"Traktorer","trucks-and-trailers":"Lastebil og henger","vans":"Varebiler"}');

// locales/da.mjs
var messages3 = JSON.parse(`{"agriculture-tools":"Maskiner og materiel","atvs":"ATV'er","boat":"B\xE5d","boat-docks-for-sale":"B\xE5dpladser til salg/leje","boat-docks-wanted":"B\xE5dplads \xF8nskes","boat-engine-parts":"Motordele til b\xE5de til salg","boat-engines-for-sale":"B\xE5dmotorer","boat-engines-wanted":"B\xE5dmotorer \xF8nskes","boats-for-rent":"B\xE5der til leje","boats-for-sale":"B\xE5de","boats-wanted":"B\xE5de s\xF8ges","buses-and-minibuses":"Busser og minibusser","b2b":"Landbrugsmaskiner","car-and-caravan":"Bil og campingvogn","caravans":"Campingvogne","cars":"Biler","construction":"Byggeri og anl\xE6g","harvesters":"Mejet\xE6rskere","mobilehomes":"Autocampere","mc":"MC","motorcycles":"Motorcykler","scooters-and-mopeds":"Scootere og knallerter","snowmobiles":"Snescootere","tractors":"Traktorer","trucks-and-trailers":"Lastbil og trailer","vans":"Varebiler"}`);

// src/i18n.ts
i18n.load({ en: messages, nb: messages2, da: messages3 });
var activateLocaleByUrl = (url) => {
  if (url.host.includes("finn.no")) {
    i18n.activate("nb" /* NORWEGIAN */);
  } else if (url.host.includes("dba.dk")) {
    i18n.activate("da" /* DANISH */);
  } else {
    i18n.activate("en" /* ENGLISH */);
  }
};

// src/getBreadcrumbs/getBreadcrumbs.ts
var getBreadcrumbsForUrl = (url, searchParams) => {
  activateLocaleByUrl(url);
  const breadcrumbs = resolveBreadcrumbForUrl(url);
  return {
    breadcrumbs,
    jsonLd: getJsonLdForBreadcrumbs(breadcrumbs, url.origin, searchParams)
  };
};
var getBreadcrumbsForAd = (pageUrl, ad) => {
  activateLocaleByUrl(pageUrl);
  const breadcrumbs = resolveBreadcrumbForAd(ad, pageUrl.origin);
  return {
    breadcrumbs,
    jsonLd: getJsonLdForBreadcrumbs(breadcrumbs, pageUrl.origin)
  };
};

export { getBreadcrumbsForAd, getBreadcrumbsForUrl, getBrowsePath, getSearchPath, getTrackingEventCategory };
